import { useAuth } from '../lib/auth';
import {
  saveMemberContact,
  useMember,
  type MemberContact,
} from '../lib/members';
import MemberForm from '../components/MemberForm';

export default function Profile() {
  const { user } = useAuth();
  const { member, loading, error } = useMember(user?.uid ?? null);

  if (loading) return <p>Laddar profil…</p>;
  if (error) return <p className="text-bad">Kunde inte ladda profil.</p>;
  if (!member || !user) return null;

  const initial: MemberContact = {
    firstName: member.firstName,
    lastName: member.lastName,
    address: member.address,
    postalCode: member.postalCode,
    city: member.city,
    alternateAddress: member.alternateAddress,
    phoneLandline: member.phoneLandline,
    phoneMobile: member.phoneMobile,
    spouse: member.spouse,
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-navy">Min profil</h1>
      <p className="text-sm text-gray-600">
        E-post: <strong>{member.email}</strong> (kan inte ändras här)
      </p>
      <MemberForm
        initial={initial}
        onSave={(values) => saveMemberContact(user.uid, values)}
      />
    </div>
  );
}
